import { observer } from 'mobx-react-lite'
import type { DraftJobViewModel } from '@/features/jobs/drafting/DraftJobViewModel'
import {
  WizardNav,
  WizardNavList,
  WizardNavListItem,
  WizardNavScroller,
} from '@/components/Wizard/WizardNav'
import type { StepViewModel } from '@/features/jobs/drafting/OutlineViewModel'
import { links } from '@/utils/link'
import { DraftJobNavigationModal } from '@/features/jobs/drafting/components/DraftJobNavigationModal'

interface DraftJobNavContainerProps {
  vm: DraftJobViewModel
  isInDialog?: boolean
}

/**
 * Info Gathering Nav Container
 */
export const DraftJobNavContainer = observer(function DraftJobNavContainer({
  vm,
  isInDialog,
}: DraftJobNavContainerProps) {
  return (
    <WizardNav>
      <WizardNavScroller spacingY="xl">
        <WizardNavList variant={isInDialog ? 'flat' : 'default'}>
          {vm.outlineVm.stepAccessors.map((stepAccessor) => (
            <DraftJobWizardNavListItemContainer
              vm={vm}
              stepVm={stepAccessor.step}
              key={stepAccessor.step.stepId}
            />
          ))}
        </WizardNavList>
      </WizardNavScroller>
    </WizardNav>
  )
})

interface DraftJobWizardNavListItemContainerProps {
  stepVm: StepViewModel
  vm: DraftJobViewModel
}

/**
 * Tax Info Gathering Wizard Nav List Item Container
 */
const DraftJobWizardNavListItemContainer = observer(
  function DraftJobWizardNavListItemContainer({
    vm,
    stepVm,
  }: DraftJobWizardNavListItemContainerProps) {
    const isSkeleton = vm.prepare.pending

    return (
      <WizardNavListItem
        replace
        isRequired={false}
        isSkeleton={isSkeleton}
        label={stepVm.outlineDisplay.title}
        to={links.editDraftJob(vm.job.id, { step: stepVm.stepId })}
        isCompleted={stepVm.isCompleted}
        isActive={vm.outlineVm.activeStep === stepVm}
        onPress={vm.outlineModalVm.close}
        testId={`draft-step-nav-item-${stepVm.stepId}`}
      />
    )
  },
)

interface DraftJobNavigationModalContainerProps {
  vm: DraftJobViewModel
}

/**
 * Info Gathering Navigation Modal Container
 */
export const DraftJobNavigationModalContainer = observer(
  function DraftJobNavigationModalContainer({
    vm,
  }: DraftJobNavigationModalContainerProps) {
    return (
      <DraftJobNavigationModal
        isOpen={vm.outlineModalVm.showing}
        onClose={vm.outlineModalVm.close}
        closeTestId="draft-nav-modal-close-button"
      >
        <DraftJobNavContainer isInDialog vm={vm} />
      </DraftJobNavigationModal>
    )
  },
)
